import brand from '@helpers/brand';
import { setCssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import styled, { css } from 'styled-components';
const H1Styles = css `
  ${fonts.gazpacho.medium};
  font-size: 42px;
  line-height: 48px;
  margin-bottom: 16px;
  ${setCssVar('fgColor', brand.sage.sageDark)};
  color: var(--fgColor);

  @media ${from(Device.DesktopSmall)} {
    font-size: 60px;
    line-height: 70px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 70px;
    line-height: 80px;
  }
`;
const H2Styles = css `
  ${fonts.gazpacho.medium};
  font-size: 36px;
  line-height: 42px;
  margin-bottom: 16px;
  ${setCssVar('fgColor', brand.sage.sageDark)};
  color: var(--fgColor);

  @media ${from(Device.Tablet)} {
    line-height: 46px;
  }

  @media ${from(Device.DesktopSmall)} {
    font-size: 40px;
    line-height: 50px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 50px;
    line-height: 60px;
  }
`;
const H3Styles = css `
  ${fonts.gazpacho.medium};
  font-size: 24px;
  line-height: 28px;
  margin-bottom: 16px;
  ${setCssVar('fgColor', brand.sage.sageDark)};
  color: var(--fgColor);

  @media ${from(Device.Tablet)} {
    font-size: 28px;
    line-height: 34px;
  }

  @media ${from(Device.DesktopSmall)} {
    font-size: 32px;
    line-height: 38px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 36px;
    line-height: 42px;
  }
`;
const H4Styles = css `
  ${fonts.gazpacho.medium};
  font-size: 18px;
  line-height: 26px;
  margin-bottom: 16px;
  ${setCssVar('fgColor', brand.sage.sageDark)};
  color: var(--fgColor);

  @media ${from(Device.Tablet)} {
    font-size: 22px;
    line-height: 30px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 24px;
    line-height: 32px;
  }
`;
const H5Styles = css `
  ${fonts.matter.medium};
  font-size: 14px;
  line-height: 17px;
  margin-bottom: 16px;
  text-transform: uppercase;
  ${setCssVar('fgColor', brand.sage.sageDark)};
  color: var(--fgColor);

  @media ${from(Device.Tablet)} {
    font-size: 16px;
    line-height: 24px;
  }
`;
const Heading = styled.h1 `
  ${({ visual }) => {
    switch (visual) {
        case 'h1':
            return H1Styles;
        case 'h2':
            return H2Styles;
        case 'h3':
            return H3Styles;
        case 'h4':
            return H4Styles;
        case 'h5':
            return H5Styles;
        default:
            break;
    }
}}
`;
const HeadingStyles = {
    H1Styles,
    H2Styles,
    H3Styles,
    H4Styles,
    H5Styles,
    Heading,
};
export default HeadingStyles;
